// extracted by mini-css-extract-plugin
module.exports = {"unclickable":"pagination_unclickable__1gX19","wrapper":"pagination_wrapper__3DsSo","active":"pagination_active__CDyMB"};